export default function showToast(message, type = 'success', duration = 7000) {
    // Dismiss any existing visible toast to avoid overlap
    const existingToast = document.querySelector('.toast.show');
    if (existingToast) {
        existingToast.classList.remove('show');
        existingToast.addEventListener('transitionend', () => existingToast.remove());
    }
    // Create toast element
    const toast = document.createElement('div');
    toast.className = `toast ${type}`;

    // Provide icon based on type
    const icons = {
        success: '✅',
        error: '⚠️',
        info: 'ℹ️',
        warning: '⚠️'
    };

    toast.innerHTML = `
        <span class="toast-icon">${icons[type] || '🔔'}</span>
        <span class="toast-message">${message}</span>
    `;

    // Append to body
    document.body.appendChild(toast);

    // Trigger reflow for transition
    setTimeout(() => {
        toast.classList.add('show');
    }, 50);

    // Hide after duration
    setTimeout(() => {
        toast.classList.remove('show');
        toast.addEventListener('transitionend', () => {
            toast.remove();
        });
    }, duration);
} 